module.exports = "https://cdn.redage.net/src/views/player/help/images/lost2.jpg";